


import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { Link } from 'react-router-dom';
import '../styles/Home.css';

const Home = () => {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  const services = [
    { img: '/images/network17.png', title: 'Network Design Services', desc: 'Our Managed Services are expertly designed to optimize your IT infrastructure for optimal performance and security in a cost-effective manner.', link: '/services/NetworkDesign' },
    { img: '/images/telecom17.png', title: 'Telecom Support Services', desc: 'Optimize your telecom systems for seamless communication and better efficiency.', link: '/services/TelecomSupport' },
    { img: '/images/webmob17.png', title: 'Web & App Development', desc: 'We build responsive, scalable digital solutions to grow your online presence.', link: '/services/WebAndApp' },
    { img: '/images/data17.png', title: 'Data Center Solution', desc: 'Tailored data center solutions for performance, redundancy, and reliability.', link: '/services/DataCenter' },
    { img: '/images/desktop17.png', title: 'Desktop Support', desc: 'Fast, efficient desktop support to keep your team productive.', link: '/services/desktop-support' },
    { img: '/images/manage17.png', title: 'Managed Services', desc: 'Comprehensive IT service management for streamlined operations.', link: '/services/ManagedServices' },
    { img: '/images/cyber17.png', title: 'Cyber Security', desc: 'Robust protection solutions to safeguard your digital assets and ensure business continuity', link: '/services/CyberSecurity' },
    { img: '/images/hardware17.png', title: 'Hardware Support & Supply', desc: 'We provide reliable hardware support and supply for your IT infrastructure.', link: '/services/HardwareSupport' }
  ]; 

  return (
    <section className="container py-5">
      <h2 className="text-center mb-5 premium-heading" data-aos="fade-up">Our Services</h2>
      {services.map((service, index) => (
        <div className="row align-items-center mb-5 service-row" key={index} data-aos="zoom-in">
          <div className="col-md-8">
            <img
              src={service.img}
              alt={service.title}
              className={`img-fluid service-img ${
                service.title === 'Cyber Security' || service.title === 'Hardware Support & Supply'
                  ? 'custom-img-size'
                  : ''
              }`}
            />
          </div>
          <div className="col-md-4">
            <div className="service-content">
              <h3 className="service-title">{service.title}</h3>
              <p className="service-desc">{service.desc}</p>
              <div className="btn-container">
                <Link to={service.link} className="read-more-btn">
                  Read More <span className="arrow">→</span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      ))}
    </section>
  );
};

export default Home;



